import React, { useState } from "react";
import { workspaces as workspacesApi } from "apis/callables";
import type StripeTypes from "stripe";
import { logger } from "js/react/views/UserOptions/panes/BillingPane/Components/PaymentMethodBlock";

// Common interface for promo form props
export interface IPromoFormProps {
    verifyPromoCode: (promoCode: StripeTypes.PromotionCode) => Promise<void>;
}

// Common hook for promo form logic
export const usePromoFormLogic = (verifyPromoCode: (promoCode: StripeTypes.PromotionCode) => Promise<void>) => {
    const [isAddingPromo, setIsAddingPromo] = useState(false);
    const [isApplyingPromo, setIsApplyingPromo] = useState(false);
    const [promoError, setPromoError] = useState<string | null>(null);
    const [promoCode, setPromoCode] = useState("");

    const handleAddPromo = () => {
        setIsAddingPromo(true);
    };

    const handleChangePromoCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newCode = e.target.value;

        setPromoCode(newCode);
        setPromoError(null);

        if (promoCode !== "" && newCode === "") {
            setIsAddingPromo(false);
        }
    };

    const handleApplyPromo = async () => {
        setIsApplyingPromo(true);

        try {
            const promotionCode = await workspacesApi.getPromotionCode({ promotionCode: promoCode });
            await verifyPromoCode(promotionCode);
        } catch (err) {
            logger.error(err, `[PromoForm] handleApplyPromo() failed`);
            setPromoError(err.message);
        } finally {
            setIsApplyingPromo(false);
        }
    };

    return {
        isAddingPromo,
        isApplyingPromo,
        promoError,
        promoCode,
        handleAddPromo,
        handleChangePromoCode,
        handleApplyPromo
    };
};
